import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmationDialog, ConfirmationMessageComponent } from '../../comman-components/confirmation-message/confirmation-message.component';
import { MasterService } from '../master.service';
import { ContractorDialogComponent } from './contractor-dialog/contractor-dialog.component';

export interface PeriodicElement {
  contactPerson: string;
  contactPersonNo: string;
  contractorName: number;
  emailId: string;
}
@Component({
  selector: 'app-contractor',
  templateUrl: './contractor.component.html',
  styleUrls: ['./contractor.component.scss']
})
export class ContractorComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public displayedColumns = ['position','contractorName', 'contactPerson', 'contactPersonNo','emailId','panNo','status', 'action'];
  dataSource = new MatTableDataSource<PeriodicElement>();
  messageTitle: string;
  status: string;
  constructor(private masterService: MasterService, public dialog: MatDialog, private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.getContratorData();
  }

  getContratorData() {
    this.masterService.getAllContractor().subscribe(res => {
      this.dataSource.data = res;
      this.dataSource.paginator = this.paginator;
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim();
  }

  public createContractorDailog(userObj?) {
    let dialogRef = this.dialog.open(ContractorDialogComponent, {
      width: '600px',
      data: userObj
    });
    dialogRef.afterClosed().subscribe(data => {
      const payload = {
        "accountNo": data?.accountNo,
        "address": {
          "addressLine1": data.addressLine1,
          "addressLine2": data.addressLine2,
          "city": data.city,
          "district": data.district,
          "pincode": data.pincode,
          "state": data.state,
          "taluka": data.taluka
        },
        "contactPerson": data.contactPerson,
        "contactPersonNo": data.contactPersonNo,
        "contractorName": data.contractorName,
        "emailId": data.emailId,
        "ifscCode": data.ifscCode,
        "panNo": data.panNo,
        "status": data.status,
        "tdsPer": data.tdsPer
      };
      (data.contractorKey) ? this.updateContractor(data.contractorKey, payload) : this.saveContractor(payload);
    });
  }

  saveContractor(payload) {
      this.masterService.addNewContractorItem(payload).subscribe(res => {
        this.snackBar.open('New Contractor added successfully!', 'Cancel', {
          duration: 3000, verticalPosition: 'top', panelClass: ['if-success']
        });
        this.getContratorData();
      },
        (error) => {
          if (error) {
            this.snackBar.open(error, 'Cancel', {
              duration: 3000, verticalPosition: 'top', panelClass: ['if-error']
            });
          }
        }
      )
  }

  updateContractor(contractorKey, payload) {
      this.masterService.updateContractorItem(contractorKey, payload).subscribe(res => {
        this.snackBar.open('Updated contractor successfully!', 'Cancel', {
          duration: 3000, verticalPosition: 'top', panelClass: ['if-success']
        });
        this.getContratorData();
      },
        (error) => {
          if (error) {
            this.snackBar.open(error, 'Cancel', {
              duration: 3000, verticalPosition: 'top', panelClass: ['if-error']
            });
          }
        }
      )
  }

  deleteContractor(id, status) {
    if(status === 'ACTIVE'){
      this.messageTitle = 'Do you want to Deactivate Site';
      this.status = 'INACTIVE';
    } else {
      this.messageTitle = 'Do you want to Activate Site';
      this.status = 'ACTIVE'
    }
    let Data:ConfirmationDialog = {
      title:'Site Status  Confirmation',
      message: this.messageTitle,
      yes: 'Yes',
      no: 'No'
    }
    const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      width: '400px',
      height: '200px',
      position: { top: '200px' },
      data: Data
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.masterService.deleteContractor(id, this.status).subscribe(res => {
          this.snackBar.open(res.message, 'Cancel', {
            duration: 3000, verticalPosition: 'top', panelClass: ['if-success']
          });
          this.getContratorData();
        },
          (error) => {
            if (error) {
              this.snackBar.open(error, 'Cancel', {
                duration: 5000, verticalPosition: 'top', panelClass: ['if-error']
              });
            }
          });
      }
    });
  }
}
